export default ngModule => {
  require('./form-directives')(ngModule);
  require('./feature-label')(ngModule);
  require('./date')(ngModule);
  require('./debug-directives')(ngModule);
  require('./basic-page')(ngModule);
  require('./multiselect')(ngModule);
  require('./app-scaffold')(ngModule);
  require('./chat-widget')(ngModule);
  require('./service-filters')(ngModule);
  require('./fund-filters')(ngModule);
  require('./zoho-error')(ngModule);
  require('./corporate-script')(ngModule);
  require('./corporate-success-script')(ngModule);
  require('./corporate-question-label')(ngModule);
  require('./active-quote-banner')(ngModule);
  require('./save-quote')(ngModule);
  require('./operator-field-note')(ngModule);
}


// WEBPACK FOOTER //
// ./src/directives/index.js